/*
 * @Author: dali
 * @Date: 2022-09-26 19:00:48
 * @LastEditors: liuzhezhe 3449223724@qq.com
 * @LastEditTime: 2024-05-13 13:11:26
 * @FilePath: \gerlun-react-website\src\pages\pre-order-ex\index.jsx
 * @Description:
 */
import React, { useRef, useEffect, useState } from 'react'
import { Button, Form, Input, message } from 'antd'
import User from '@/modules/user'
import CountDownBtn from '@/components/countDownBtn'
import wrapWithUser from '@/components/wrapWithUser'
import { addListenerPrePhone } from '@/events'
import styles from './index.scss'
import p1 from '@/common/images/pageHome/p-1.png'
import p2 from '@/common/images/pageHome/p-2.png'
import { isMobileAgent, is_weixn } from '@/utils/utils'
import { SYSCON } from '@/const/const.js'
import ProvinceCityDropdown from '@/components/City/index'
const PreOrderEx = (props) => {
  const formRef = useRef()
  const [form] = Form.useForm()
  const countRef = React.createRef()
  const [showCityFlag, handleShowCityFlag] = useState(false)
  const [showProvinceNmFlag, handleProvinceNmFlag] = useState(false)
  const [provinceNm, setProvinceNm] = useState('') // 省份名称
  const [cityNm, setCityNm] = useState('') // 市名称

  // 用户初始化
  const user = new User()

  useEffect(
    () => {
      // 注册事件监听，把事件触发时要调用的处理函数传递过去。
      // 运行一次即可
      addListenerPrePhone(phoneHandler)
    }, []
  )
  // 组件间通讯事件触发时的处理。
  function phoneHandler(args) {
    form.setFieldsValue({
      applicantPhone: args || ''
    })
  }

  const phoneValid = () => ({
    validator(_, value) {
      return checkPhoneValue(value)
    }
  })

  const validateVcode = () => ({
    validator(_, value) {
      console.log('valuevaluevaluevaluevalue', value)
      if (value) {
        const cnReg = new RegExp('[\\u4E00-\\u9FFF]+', 'g')
        if (cnReg.test(value)) {
          return Promise.reject(new Error('验证码不能为中文'))
        } else {
          return Promise.resolve()
        }
      } else {
        return Promise.reject('验证码不能为空')
      }
    }
  })

  const checkPhoneValue = async(value) => {
    console.log('value', value)

    if (value && value.length !== 11) {
      return Promise.reject(new Error('请输入11位的手机号!'))
    }
    console.log('value - 0', value - 0)

    if (!Number.isInteger(value - 0)) {
      return Promise.reject(new Error('请输入正确格式的手机号!'))
    }

    return Promise.resolve()
  }

  const cnInputCheck = (event) => {
    return event.target.value.replace(/[\u4E00-\u9FA5]/g, '').replace(/\s/g, '')
  }
  const onFinish = async(values) => {
    if (!provinceNm || !cityNm) return
    const hide = message.loading('请稍等')
    const phoneResult = await user.checkPhone({ phone: values.applicantPhone })
    if (phoneResult) {
      return message.warning('您已注册，请登录后跳转到工作台进行试用')
    } else {
      let srcCd
      if (is_weixn()) {
        srcCd = SYSCON.ProdTrialSrcWxMp
      } else {
        srcCd = isMobileAgent() ? SYSCON.ProdTrialSrcWebsiteMobile : SYSCON.ProdTrialSrcWebsitePC
      }
      const data = {
        ...values,
        provinceNm,
        cityNm,
        srcCd
      }
      console.log({ data })
      user.onAppointment(data)
        .then(async() => {
          hide()
          setTimeout(()=>{
            message.success('提交成功，我们的客服会在第一时间联系您，您也可以主动联系客服开通')
            form.resetFields()
          }, 300)
        })
        .catch(err => {
          // form.resetFields()
          console.log(err)
          hide()
        })
    }
  }
  const handleSend = () => {
    const { applicantPhone } = form.getFieldsValue()
    console.log('applicantPhone', applicantPhone)

    return checkPhoneValue(applicantPhone).then(()=>{
      user.sendCode({ phone: applicantPhone })
      return Promise.resolve()
    }).catch((err)=>{
      return Promise.reject(err)
    })
  }
  const handleCityData = (cityObj) => {
    setProvinceNm(cityObj.province)
    setCityNm(cityObj.city)
  }
  const validateCity = () => ({
    validator(_, value) {
      if (!provinceNm) {
        handleProvinceNmFlag(true)
      } else {
        handleProvinceNmFlag(false)
      }
      if (!cityNm) {
        handleShowCityFlag(true)
        return Promise.reject('')
      } else {
        handleShowCityFlag(false)
        return Promise.resolve()
      }
    }
  })
  return (
    <div id='preOrderEx' className={`${styles['content']} flex justify-center flex-column align-center relative`}>
      <img src={p1} className={styles['img-left']} alt='left' />
      <img src={p2} className={styles['img-right']} alt='right' />
      <div className={styles['titles']}>
        <p className={styles['title']}>
        概而论——您的票财税一体化管理专家
        </p>
        <p className={styles['sub-title']}>
       高效智能的财税SaaS平台
        </p>
      </div>
      <div className={styles['form-content']}>
        <Form form={form} ref={formRef} onFinish={onFinish} validateTrigger={['onSubmit']} name='appointment'>
          <Form.Item
            name='applicantNm'
            rules={[
              { required: true, message: '姓名不能为空' },
              { max: 100, message: '不能超过100位' }
            ]}
          >
            <Input placeholder='请输入您的姓名' autoComplete='off' />
          </Form.Item>
          <Form.Item
            name='rootOrgNm'
            rules={[
              { required: true, message: '公司名称不能为空' },
              { max: 100, message: '不能超过100位' }
            ]}
          >
            <Input placeholder='请输入您的公司名称' autoComplete='off' />
          </Form.Item>
          <Form.Item name='provinceNm' rules={[validateCity]}>
            <ProvinceCityDropdown showCityFlag={showCityFlag} showProvinceNmFlag={showProvinceNmFlag} onChildClick={handleCityData} />
            { showCityFlag || showProvinceNmFlag ? <span style={{ color: '#ff4d4f', marginBottom: '-19px', display: 'block' }}>所属地区不能为空</span> : '' }
          </Form.Item>
          <Form.Item name='applicantPhone' rules={[{ required: true, message: '手机号不能为空' }, phoneValid]}>
            <Input placeholder='请输入您的手机号码' autoComplete='off' />
          </Form.Item>
          <Form.Item style={{ marginBottom: 0 }} >
            <Form.Item name='code' rules={[validateVcode]} style={{ display: 'inline-block', width: 'calc(74% - 8px)' }} getValueFromEvent={cnInputCheck}>
              <Input placeholder='请输入验证码' autoComplete='off' />
            </Form.Item>
            <Form.Item style={{ display: 'inline-block', width: 'calc(26% - 8px)', margin: '0 8px' }}>
              <div className={styles['c-btn']}>
                <CountDownBtn ref={countRef} handleSend={handleSend} desc='获取验证码'/>
              </div>
            </Form.Item>
          </Form.Item>
          <div className={styles['btns']}>
            <Button type='primary' htmlType='submit' block>
              预约体验
            </Button>
          </div>
        </Form>
      </div>

    </div>
  )
}

export default wrapWithUser(PreOrderEx)
